// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IStoreItem,
}                               from '../interfaces';

const stripeGetStoreItems = async ({
    test,
    negotiationRequestPriceIds,
    paymentIntentId,
}: {
    negotiationRequestPriceIds?: string[],
    paymentIntentId?: string,
    test: boolean,
}): Promise<Map<string, IStoreItem>> => {
    const functions = getFunctions();
    const getStoreItems = httpsCallable<
        Record<
            string,
            boolean | string | string[] | undefined
        >,
        {
            [k: string]: IStoreItem,
        }
    >(
        functions,
        'stripeGetStoreItems',
    );

    return getStoreItems({
        negotiationRequestPriceIds,
        paymentIntentId,
        test,
    }).then((result) => {
        const storeItems: Map<string, IStoreItem> = new Map(Object.entries(result.data));
        return storeItems;
    }).catch((err) => {
        throw err;
    });
};

export default stripeGetStoreItems;
